import { EventEmitter } from '@angular/core';

export class SearchService {
    public search: EventEmitter<string> = new EventEmitter();
    public clearSearch: EventEmitter<any> = new EventEmitter();

    constructor() { }

    emitSearchEvent(searchText: string) {
        this.search.emit(searchText);
    }

    emitClearSearchEvent() {
        this.clearSearch.emit();
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/search.service.ts